<template>
    <section class="pageHead">
        <div class="full-col">
            <div class="col col_2_of_3">
                <h1 itemprop="headline">{{ pageTitle }}</h1>
                <div class="checkoutSteps" v-if="isCheckout">
                    <div class="checkoutStep" id="checkoutStep1"
                    @click="$emit('changeStep', 1)" 
                    :class="{ 'checkoutStepDone': steps.step1.completed, 'checkoutStepActive': stepActive('Step 1') }">
                        <span class="stepNumber">1</span><span class="stepTitle">Submit Document</span>
                    </div>

                    <div class="checkoutStep" id="checkoutStep2" 
                    @click="$emit('changeStep', 2)" 
                    :class="{ 'checkoutStepDone': steps.step2.completed, 'checkoutStepActive': stepActive('Step 2') }">
                        <span class="stepNumber">2</span><span class="stepTitle">Calculate Price</span>
                    </div>

                    <div class="checkoutStep" id="checkoutStep3" v-if="accountData.CustomerType=='guest'"
                    @click="$emit('changeStep', 3)" 
                    :class="{ 'checkoutStepDone': steps.step3.completed, 'checkoutStepActive': stepActive('Step 3') }">
                        <span class="stepNumber">3</span><span
                            class="stepTitle">Payment</span>
                    </div>

                    <div class="checkoutStep" id="checkoutStep4" v-if="accountData.CustomerType=='guest'" 
                    @click="$emit('changeStep', 4)" 
                    :class="{ 'checkoutStepDone': steps.step4.completed, 'checkoutStepActive': stepActive('Step 4') }">
                        <span class="stepNumber">4</span><span class="stepTitle">Confirm</span>
                    </div>
                    <div class="checkoutStep" id="checkoutStep5" v-if="accountData.CustomerType=='guest'" 
                    :class="{ 'checkoutStepActive': stepActive('Step 5') }">
                        <span class="stepNumber">5</span><span
                            class="stepTitle">Success</span>
                    </div>

                    <div class="checkoutStep" id="checkoutStep3Cor" v-if="accountData.CustomerType!='guest'" 
                    @click="$emit('changeStep', 3)"  
                    :class="{ 'checkoutStepDone': steps.step4.completed, 'checkoutStepActive': stepActive('Step 4') }"
                    >
                        <span class="stepNumber">3</span><span class="stepTitle">Confirm</span>
                    </div>

                    <div class="checkoutStep" id="checkoutStep4Cor" v-if="accountData.CustomerType!='guest'" 
                    :class="{ 'checkoutStepDone': steps.step5.completed, 'checkoutStepActive': stepActive('Step 5') }">
                        <span class="stepNumber">4</span><span class="stepTitle">Success</span>
                    </div> 
                           
                    <div class="clearAll"></div>
                </div>
            </div>
            <div class="col col_1_of_3 alignRight" style="padding-top: 25px;">
                <div class="secureRight">
                    <span id="siteseal"></span>
                </div>
            </div>
        </div>
        <div class="clearAll"></div>
    </section>
</template>

<script>
//import ''
export default {
    mounted() {
        this.initScripts();
    },
    data() {
        return {
            
        };
    },
    props: {
        pageTitle: String,
        isCheckout: Boolean,
        accountData: Object,
        SelectedData: Object,
        steps: Object,
    },
    methods: {
        initScripts() {
            const recaptchaScript = document.createElement("script");
            recaptchaScript.setAttribute(
                "src",
                "https://seal.godaddy.com/getSeal?sealID=1Reh8DTkb6GsGoYD00OZUKwl0IpuytlWXrGA9kLh0WIg9pfUQTU3qMIqu6zB"
            );
            document.body.appendChild(recaptchaScript);
        },
        stepActive(step) {
            if(this.SelectedData.stepActive == step) {
                return true;
            }
            return false;
        }
    }
}
</script>

<style>
.pageHead {
    background: #f5f1ea;
}

.pageHead h1 {
    color: #3c82b5;
    font-weight: 600;
    font-size: 32px;
    line-height: 34px;
    margin: 25px 0 15px 0;
}

.pageHeadSubText {
    font-size: 18px;
    line-height: 22px;
    font-style: italic;
    color: #6b5846;
}

.pageHead .turnText {
    background: #e87b17;
    padding: 15px 5%;
}

.checkoutStep {
    float: left;
    position: relative;
    height: 30px;
    margin-right: 18px;
    cursor: pointer;
    z-index: 1;
}

.stepNumber {
    font-size: 50px;
    line-height: 50px;
    font-weight: 700;
    font-style: italic;
    position: absolute;
    left: 0;
    bottom: -5px;
    color: #d6dee1;
    z-index: 1;
}

.stepTitle {
    color: #c3c0bc;
    font-size: 16px;
    line-height: 44px;
    padding-left: 15px;
    z-index: 2;
    position: relative;
    font-weight: 600;
}

.checkoutStepActive .stepNumber {
    color: #f3ddc6;
}

.checkoutStepActive .stepTitle {
    color: #dc7b22;
}

.checkoutStepDone .stepNumber {
    color: #dbe6af;
}

.checkoutStepDone .stepTitle {
    color: #8fc400;
}</style>